export default {
      id: "ic_setting-usage",
      viewBox: "0 0 24 25",
      url: "/" + "images/icons.3.109.2.svg#ic_setting-usage",
      toString: function () {
        return this.url;
      }
    }